export default class BraintreeError extends Error {}
